import CASL from '@/utils/constants/casl'

export default {
  path: 'tambahan-material-jasa',
  children: [
    {
      path: '',
      name: 'tambahan-material-jasa.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.FINANCE.PEMBELIAN_CHARGER
      },
      component: () => import('./list/TambahanMaterialJasaListPage.vue')
    },
    {
      path: ':uid/:validateUid',
      name: 'tambahan-material-jasa.detail',
      meta: {
        action: 'update',
        subject: CASL.ACCESS.FINANCE.PEMBELIAN_CHARGER
      },
      component: () => import('./form/TambahanMaterialJasaFormPage.vue')
    }
  ]
}
